type AddressLike = {
  aptsuite?: string | null;
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
};

export function formatFacilityAddress(address: AddressLike | null | undefined): string | null {
  if (!address?.street) {
    return null;
  }

  const line1 = [address.aptsuite, address.street].filter(Boolean).join(' ');
  const line2 = [address.city, address.state].filter(Boolean).join(', ');
  const line3 = [line2, address.zip].filter(Boolean).join(' ').trim();

  return [line1, line3].filter(Boolean).join(', ') || null;
}
